import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@heroui/react';
import type { AccountType } from '@/api/models';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import {
    ACCOUNT_TYPE_CHIP_CLASS,
    ACCOUNT_TYPE_LABEL_KEY,
} from '../chartOfAccountsMeta';

type AccountTypeChipProps = {
    type: AccountType;
    accountId: string;
};

/**
 * The per-type tag, shown on every row — headers as well as postable leaves. A
 * class or group carries the same type as everything beneath it, and with the
 * standard chart four levels deep a collapsed branch should still say what it
 * is. The colour is decorative; the localized label text carries the meaning,
 * so it is never colour-only.
 */
export const AccountTypeChip: React.FC<AccountTypeChipProps> = ({
    type,
    accountId,
}) => {
    const { t } = useTranslation('pages');

    return (
        <Chip
            className={`${ACCOUNT_TYPE_CHIP_CLASS[type]} border-0`}
            size="sm"
            variant="soft"
            {...getNodeTestIdProp(`chart-of-accounts-type-chip-${accountId}`)}
        >
            <Chip.Label>{t(ACCOUNT_TYPE_LABEL_KEY[type])}</Chip.Label>
        </Chip>
    );
};
